import * as z from 'zod';

export const CUSTOMER_FORM_SCHEMA = () =>
  z.object({
    customerName: z.string().trim().min(1, 'Customer name is required'),
    customerId: z.string().trim().min(1, 'Customer ID is required'),
    email: z
      .string()
      .trim()
      .min(1, 'Email address is required')
      .email('Enter a valid email address')
  });

export type CustomerFormSchema = z.infer<
  ReturnType<typeof CUSTOMER_FORM_SCHEMA>
>;
